<template>
  <div class="main-wrapper domain-hosting">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <h2>Dreams Domain</h2>
            </div>
            <div class="inv-header-right">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
          </div>
          <div class="flight-invoice-details">
            <h3>Tax Invoice</h3>
            <div class="invoice-infomation">
              <div>Customer ID: <span>#326725</span></div>
              <div>Invoice Date: <span>05/01/2023</span></div>
              <div>Invoice No: <span>#00001</span></div>
            </div>
          </div>
          <div class="invoice-address">
            <div class="invoice-to">
              <span>Bill To:</span>
              <div class="inv-to-address">
                Walter Roberson<br />
                299 Star Trek Drive, Panama City, <br />
                Florida, 32405, USA.<br />
                walter@example.com <br />
                +45 5421 4523
              </div>
            </div>
          </div>
          <div class="service-details">
            <h4>Domain Details:</h4>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="services">DESCRIPTION</th>
                    <th class="charged-amount">PRICE</th>
                    <th class="discount">DISCOUNT</th>
                    <th class="total">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      1 Domain - (.com Domain Registration with SSL) 2 Yearsdomainname.com
                    </td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>50</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="invoice-table-footer">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">DISCOUNT 25%</td>
                      <td class="">
                        <div>$ <span>50.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer table-total-item">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">TOTAL AMOUNT</td>
                      <td class="">
                        <div>$ <span>150.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <h4>Hosting Details:</h4>
            <div class="table-responsive room-detail-table">
              <table>
                <thead>
                  <tr>
                    <th class="description">DESCRIPTION</th>
                    <th class="charged-amount">AMOUNT</th>
                    <th class="discount">DISCOUNT</th>
                    <th class="total">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>25 GB Hosting - (Business Package #SHP2564874) 2 Years</td>
                    <td>
                      <div>$<span>200</span></div>
                    </td>
                    <td>
                      <div>$<span>50</span></div>
                    </td>
                    <td>
                      <div>$<span>150</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="invoice-table-footer">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">DISCOUNT 25%</td>
                      <td class="">
                        <div>$ <span>50.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="invoice-table-footer table-total-item">
              <div class="table-footer-left"></div>
              <div class="text-end table-footer-right">
                <table>
                  <tbody>
                    <tr>
                      <td class="">SUBTOTAL</td>
                      <td class="">
                        <div>$ <span>150.00</span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="invoice-table-footer totalamount-footer">
            <div class="table-footer-left">
              <table>
                <tbody>
                  <tr>
                    <td class="">SALES TAX 10%</td>
                    <td class="">
                      <div>$ <span>90</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="">TOTAL AMOUNT</td>
                    <td class="">
                      <div>$ <span>690</span></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              Total amount ( in words): <span>USD Six Hundred Ninety Dollars Only.</span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">$690.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <p>
              Here we can write a additional notes for the client to get a better
              understanding of this invoice.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
